// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TaskRecordsPage-root {
  min-height: calc(100vh - 60px);
  color: var(--canvas-ink, #171a17);
  background: var(--canvas-paper, #f3f5f6);
}

.TaskRecordsPage-hero {
  padding: 44px 24px 34px;
  background: #fff;
  border-bottom: 1px solid var(--canvas-line, #e2e6e4);
}

.TaskRecordsPage-hero-inner,
.TaskRecordsPage-content {
  width: min(1160px, 100%);
  margin: 0 auto;
}

.TaskRecordsPage-back {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 34px;
  color: var(--canvas-muted, #737b75);
  font-size: 12px;
  text-decoration: none;
}

.TaskRecordsPage-back:hover {
  color: var(--canvas-ink, #171a17);
}

.TaskRecordsPage-kicker {
  display: block;
  margin-bottom: 10px;
  color: var(--canvas-green-strong, #70a33d);
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.14em;
}

.TaskRecordsPage-title-row {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 32px;
}

.TaskRecordsPage-title-row h1 {
  margin: 0;
  font-size: clamp(34px, 5vw, 58px);
  font-weight: 750;
  letter-spacing: -0.055em;
  line-height: 1;
}

.TaskRecordsPage-title-row p {
  margin: 16px 0 0;
  color: var(--canvas-muted, #737b75);
  font-size: 13px;
}

.TaskRecordsPage-total {
  display: flex;
  min-width: 150px;
  flex-direction: column;
  gap: 6px;
  padding: 15px 18px;
  background: var(--canvas-green-soft, #e3f3cb);
  border: 1px solid var(--canvas-green, #b9df8a);
  border-radius: 12px;
}

.TaskRecordsPage-total span {
  color: #65725c;
  font-size: 10px;
}

.TaskRecordsPage-total strong {
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 22px;
}

.TaskRecordsPage-content {
  padding: 28px 24px 80px;
}

.TaskRecordsPage-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 22px;
}

.TaskRecordsPage-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.TaskRecordsPage-filters button {
  min-width: 64px;
  padding: 8px 13px;
  color: #6b736d;
  background: #fff;
  border: 1px solid var(--canvas-line, #e2e6e4);
  border-radius: 999px;
  font-size: 11px;
}

.TaskRecordsPage-filters button:hover,
.TaskRecordsPage-filters button.is-active {
  color: var(--canvas-ink, #171a17);
  background: var(--canvas-green-soft, #e3f3cb);
  border-color: var(--canvas-green, #b9df8a);
}

.TaskRecordsPage-sync {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 7px;
  color: var(--canvas-muted, #737b75);
  font-size: 10px;
}

.TaskRecordsPage-sync i {
  width: 6px;
  height: 6px;
  background: var(--canvas-green-strong, #70a33d);
  border-radius: 50%;
}

.TaskRecordsPage-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.TaskRecordsPage-card {
  min-width: 0;
  overflow: hidden;
  background: #fff;
  border: 1px solid var(--canvas-line, #e2e6e4);
  border-radius: 13px;
  box-shadow: 0 10px 30px rgba(24, 30, 26, 0.035);
  transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease;
}

.TaskRecordsPage-card:hover {
  border-color: var(--canvas-line-strong, #ccd2ce);
  box-shadow: 0 14px 36px rgba(24, 30, 26, 0.075);
  transform: translateY(-2px);
}

.TaskRecordsPage-card-header {
  display: flex;
  min-height: 65px;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 13px 13px 11px;
}

.TaskRecordsPage-card-header > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 5px;
}

.TaskRecordsPage-card-header strong {
  overflow: hidden;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TaskRecordsPage-card-header > div > span {
  overflow: hidden;
  color: var(--canvas-muted, #737b75);
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TaskRecordsPage-status {
  display: inline-flex;
  height: 21px;
  flex: 0 0 auto;
  align-items: center;
  gap: 5px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 8px;
  font-weight: 650;
}

.TaskRecordsPage-status i {
  width: 5px;
  height: 5px;
  background: currentColor;
  border-radius: 50%;
}

.TaskRecordsPage-status.is-completed {
  color: #4f802e;
  background: #e4f3d6;
}

.TaskRecordsPage-status.is-processing {
  color: #9b6b21;
  background: #f8efd9;
}

.TaskRecordsPage-status.is-failed {
  color: #b64d49;
  background: #fae7e5;
}

.TaskRecordsPage-media {
  display: grid;
  width: calc(100% - 20px);
  height: 190px;
  margin: 0 10px;
  place-items: center;
  overflow: hidden;
  background: #e9eeeb;
  border-radius: 9px;
}

.TaskRecordsPage-media img,
.TaskRecordsPage-media video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.TaskRecordsPage-media.is-empty {
  background-image: radial-gradient(circle, rgba(86, 102, 91, 0.18) 0.7px, transparent 0.8px);
  background-size: 14px 14px;
}

.TaskRecordsPage-media-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #8a938d;
}

.TaskRecordsPage-media-placeholder span,
.TaskRecordsPage-empty-mark {
  display: grid;
  width: 42px;
  height: 42px;
  place-items: center;
  color: #fff;
  background: var(--canvas-ink, #171a17);
  border-radius: 12px;
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 11px;
  font-weight: 700;
}

.TaskRecordsPage-media-placeholder small {
  font-size: 9px;
}

.TaskRecordsPage-audio {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 20px;
}

.TaskRecordsPage-audio > span {
  display: grid;
  width: 46px;
  height: 46px;
  place-items: center;
  color: #fff;
  background: var(--canvas-ink, #171a17);
  border-radius: 50%;
  font-size: 22px;
}

.TaskRecordsPage-audio audio {
  width: 100%;
  height: 34px;
}

.TaskRecordsPage-prompt {
  min-height: 45px;
  margin: 9px 10px 0;
  padding: 10px;
  overflow: hidden;
  color: #5f675f;
  background: var(--canvas-surface-soft, #f7f8f8);
  border-radius: 8px;
  font-size: 10px;
  line-height: 1.5;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TaskRecordsPage-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 13px;
}

.TaskRecordsPage-card-footer > strong {
  color: var(--canvas-green-strong, #70a33d);
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 12px;
}

.TaskRecordsPage-card-footer small {
  font-family: inherit;
  font-size: 8px;
}

.TaskRecordsPage-card-footer time {
  color: var(--canvas-muted, #737b75);
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 8px;
}

.TaskRecordsPage-state {
  display: flex;
  min-height: 300px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 9px;
  color: var(--canvas-muted, #737b75);
  background: #fff;
  border: 1px dashed var(--canvas-line-strong, #ccd2ce);
  border-radius: 14px;
  font-size: 11px;
}

.TaskRecordsPage-state strong {
  color: var(--canvas-ink, #171a17);
  font-size: 14px;
}

.TaskRecordsPage-state button,
.TaskRecordsPage-pagination button {
  margin-top: 8px;
  padding: 9px 16px;
  color: #fff;
  background: var(--canvas-ink, #171a17);
  border: 1px solid var(--canvas-ink, #171a17);
  border-radius: 9px;
  font-size: 11px;
}

.TaskRecordsPage-spinner {
  width: 24px;
  height: 24px;
  margin-bottom: 5px;
  border: 2px solid var(--canvas-line, #e2e6e4);
  border-top-color: var(--canvas-green-strong, #70a33d);
  border-radius: 50%;
  animation: TaskRecordsPage-spin 700ms linear infinite;
}

@keyframes TaskRecordsPage-spin {
  to { transform: rotate(360deg); }
}

.TaskRecordsPage-pagination {
  display: flex;
  min-height: 74px;
  align-items: center;
  justify-content: center;
  color: var(--canvas-muted, #737b75);
  font-size: 10px;
}

.TaskRecordsPage-pagination button:disabled {
  cursor: wait;
  opacity: 0.6;
}

@media (max-width: 900px) {
  .TaskRecordsPage-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

@media (max-width: 620px) {
  .TaskRecordsPage-hero { padding: 28px 16px; }
  .TaskRecordsPage-back { margin-bottom: 26px; }
  .TaskRecordsPage-title-row { align-items: stretch; flex-direction: column; }
  .TaskRecordsPage-total { min-width: 0; }
  .TaskRecordsPage-content { padding: 20px 14px 60px; }
  .TaskRecordsPage-toolbar { align-items: flex-start; flex-direction: column; gap: 12px; }
  .TaskRecordsPage-sync { display: none; }
  .TaskRecordsPage-grid { grid-template-columns: 1fr; }
  .TaskRecordsPage-media { height: 210px; }
}

@media (prefers-reduced-motion: reduce) {
  .TaskRecordsPage-card { transition: none; }
  .TaskRecordsPage-card:hover { transform: none; }
  .TaskRecordsPage-spinner { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/taskRecords/TaskRecordsPage.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,oDAAoD;AACtD;;AAEA;;EAEE,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mCAAmC;EACnC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,0CAA0C;EAC1C,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,6CAA6C;EAC7C,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,6CAA6C;EAC7C,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;EAEE,iCAAiC;EACjC,6CAA6C;EAC7C,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;EAC7C,mBAAmB;EACnB,+CAA+C;EAC/C,gFAAgF;AAClF;;AAEA;EACE,gDAAgD;EAChD,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,kDAAkD;EAClD,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,2FAA2F;EAC3F,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,sCAAsC;EACtC,mBAAmB;EACnB,kDAAkD;EAClD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,+CAA+C;EAC/C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mCAAmC;EACnC,gBAAgB;EAChB,qDAAqD;EACrD,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,sCAAsC;EACtC,4CAA4C;EAC5C,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;EAC7C,qDAAqD;EACrD,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,wBAAwB,gDAAgD,EAAE;AAC5E;;AAEA;EACE,wBAAwB,kBAAkB,EAAE;EAC5C,wBAAwB,mBAAmB,EAAE;EAC7C,6BAA6B,oBAAoB,EAAE,sBAAsB,EAAE;EAC3E,yBAAyB,YAAY,EAAE;EACvC,2BAA2B,uBAAuB,EAAE;EACpD,2BAA2B,uBAAuB,EAAE,sBAAsB,EAAE,SAAS,EAAE;EACvF,wBAAwB,aAAa,EAAE;EACvC,wBAAwB,0BAA0B,EAAE;EACpD,yBAAyB,aAAa,EAAE;AAC1C;;AAEA;EACE,wBAAwB,gBAAgB,EAAE;EAC1C,8BAA8B,eAAe,EAAE;EAC/C,2BAA2B,eAAe,EAAE;AAC9C","sourcesContent":[".TaskRecordsPage-root {\n  min-height: calc(100vh - 60px);\n  color: var(--canvas-ink, #171a17);\n  background: var(--canvas-paper, #f3f5f6);\n}\n\n.TaskRecordsPage-hero {\n  padding: 44px 24px 34px;\n  background: #fff;\n  border-bottom: 1px solid var(--canvas-line, #e2e6e4);\n}\n\n.TaskRecordsPage-hero-inner,\n.TaskRecordsPage-content {\n  width: min(1160px, 100%);\n  margin: 0 auto;\n}\n\n.TaskRecordsPage-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  margin-bottom: 34px;\n  color: var(--canvas-muted, #737b75);\n  font-size: 12px;\n  text-decoration: none;\n}\n\n.TaskRecordsPage-back:hover {\n  color: var(--canvas-ink, #171a17);\n}\n\n.TaskRecordsPage-kicker {\n  display: block;\n  margin-bottom: 10px;\n  color: var(--canvas-green-strong, #70a33d);\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n}\n\n.TaskRecordsPage-title-row {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 32px;\n}\n\n.TaskRecordsPage-title-row h1 {\n  margin: 0;\n  font-size: clamp(34px, 5vw, 58px);\n  font-weight: 750;\n  letter-spacing: -0.055em;\n  line-height: 1;\n}\n\n.TaskRecordsPage-title-row p {\n  margin: 16px 0 0;\n  color: var(--canvas-muted, #737b75);\n  font-size: 13px;\n}\n\n.TaskRecordsPage-total {\n  display: flex;\n  min-width: 150px;\n  flex-direction: column;\n  gap: 6px;\n  padding: 15px 18px;\n  background: var(--canvas-green-soft, #e3f3cb);\n  border: 1px solid var(--canvas-green, #b9df8a);\n  border-radius: 12px;\n}\n\n.TaskRecordsPage-total span {\n  color: #65725c;\n  font-size: 10px;\n}\n\n.TaskRecordsPage-total strong {\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: 22px;\n}\n\n.TaskRecordsPage-content {\n  padding: 28px 24px 80px;\n}\n\n.TaskRecordsPage-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  margin-bottom: 22px;\n}\n\n.TaskRecordsPage-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n}\n\n.TaskRecordsPage-filters button {\n  min-width: 64px;\n  padding: 8px 13px;\n  color: #6b736d;\n  background: #fff;\n  border: 1px solid var(--canvas-line, #e2e6e4);\n  border-radius: 999px;\n  font-size: 11px;\n}\n\n.TaskRecordsPage-filters button:hover,\n.TaskRecordsPage-filters button.is-active {\n  color: var(--canvas-ink, #171a17);\n  background: var(--canvas-green-soft, #e3f3cb);\n  border-color: var(--canvas-green, #b9df8a);\n}\n\n.TaskRecordsPage-sync {\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 7px;\n  color: var(--canvas-muted, #737b75);\n  font-size: 10px;\n}\n\n.TaskRecordsPage-sync i {\n  width: 6px;\n  height: 6px;\n  background: var(--canvas-green-strong, #70a33d);\n  border-radius: 50%;\n}\n\n.TaskRecordsPage-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.TaskRecordsPage-card {\n  min-width: 0;\n  overflow: hidden;\n  background: #fff;\n  border: 1px solid var(--canvas-line, #e2e6e4);\n  border-radius: 13px;\n  box-shadow: 0 10px 30px rgba(24, 30, 26, 0.035);\n  transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.TaskRecordsPage-card:hover {\n  border-color: var(--canvas-line-strong, #ccd2ce);\n  box-shadow: 0 14px 36px rgba(24, 30, 26, 0.075);\n  transform: translateY(-2px);\n}\n\n.TaskRecordsPage-card-header {\n  display: flex;\n  min-height: 65px;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 13px 13px 11px;\n}\n\n.TaskRecordsPage-card-header > div {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.TaskRecordsPage-card-header strong {\n  overflow: hidden;\n  font-size: 12px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.TaskRecordsPage-card-header > div > span {\n  overflow: hidden;\n  color: var(--canvas-muted, #737b75);\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: 8px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.TaskRecordsPage-status {\n  display: inline-flex;\n  height: 21px;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 5px;\n  padding: 0 8px;\n  border-radius: 999px;\n  font-size: 8px;\n  font-weight: 650;\n}\n\n.TaskRecordsPage-status i {\n  width: 5px;\n  height: 5px;\n  background: currentColor;\n  border-radius: 50%;\n}\n\n.TaskRecordsPage-status.is-completed {\n  color: #4f802e;\n  background: #e4f3d6;\n}\n\n.TaskRecordsPage-status.is-processing {\n  color: #9b6b21;\n  background: #f8efd9;\n}\n\n.TaskRecordsPage-status.is-failed {\n  color: #b64d49;\n  background: #fae7e5;\n}\n\n.TaskRecordsPage-media {\n  display: grid;\n  width: calc(100% - 20px);\n  height: 190px;\n  margin: 0 10px;\n  place-items: center;\n  overflow: hidden;\n  background: #e9eeeb;\n  border-radius: 9px;\n}\n\n.TaskRecordsPage-media img,\n.TaskRecordsPage-media video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.TaskRecordsPage-media.is-empty {\n  background-image: radial-gradient(circle, rgba(86, 102, 91, 0.18) 0.7px, transparent 0.8px);\n  background-size: 14px 14px;\n}\n\n.TaskRecordsPage-media-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  color: #8a938d;\n}\n\n.TaskRecordsPage-media-placeholder span,\n.TaskRecordsPage-empty-mark {\n  display: grid;\n  width: 42px;\n  height: 42px;\n  place-items: center;\n  color: #fff;\n  background: var(--canvas-ink, #171a17);\n  border-radius: 12px;\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.TaskRecordsPage-media-placeholder small {\n  font-size: 9px;\n}\n\n.TaskRecordsPage-audio {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  padding: 20px;\n}\n\n.TaskRecordsPage-audio > span {\n  display: grid;\n  width: 46px;\n  height: 46px;\n  place-items: center;\n  color: #fff;\n  background: var(--canvas-ink, #171a17);\n  border-radius: 50%;\n  font-size: 22px;\n}\n\n.TaskRecordsPage-audio audio {\n  width: 100%;\n  height: 34px;\n}\n\n.TaskRecordsPage-prompt {\n  min-height: 45px;\n  margin: 9px 10px 0;\n  padding: 10px;\n  overflow: hidden;\n  color: #5f675f;\n  background: var(--canvas-surface-soft, #f7f8f8);\n  border-radius: 8px;\n  font-size: 10px;\n  line-height: 1.5;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.TaskRecordsPage-card-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 13px;\n}\n\n.TaskRecordsPage-card-footer > strong {\n  color: var(--canvas-green-strong, #70a33d);\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: 12px;\n}\n\n.TaskRecordsPage-card-footer small {\n  font-family: inherit;\n  font-size: 8px;\n}\n\n.TaskRecordsPage-card-footer time {\n  color: var(--canvas-muted, #737b75);\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  font-size: 8px;\n}\n\n.TaskRecordsPage-state {\n  display: flex;\n  min-height: 300px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 9px;\n  color: var(--canvas-muted, #737b75);\n  background: #fff;\n  border: 1px dashed var(--canvas-line-strong, #ccd2ce);\n  border-radius: 14px;\n  font-size: 11px;\n}\n\n.TaskRecordsPage-state strong {\n  color: var(--canvas-ink, #171a17);\n  font-size: 14px;\n}\n\n.TaskRecordsPage-state button,\n.TaskRecordsPage-pagination button {\n  margin-top: 8px;\n  padding: 9px 16px;\n  color: #fff;\n  background: var(--canvas-ink, #171a17);\n  border: 1px solid var(--canvas-ink, #171a17);\n  border-radius: 9px;\n  font-size: 11px;\n}\n\n.TaskRecordsPage-spinner {\n  width: 24px;\n  height: 24px;\n  margin-bottom: 5px;\n  border: 2px solid var(--canvas-line, #e2e6e4);\n  border-top-color: var(--canvas-green-strong, #70a33d);\n  border-radius: 50%;\n  animation: TaskRecordsPage-spin 700ms linear infinite;\n}\n\n@keyframes TaskRecordsPage-spin {\n  to { transform: rotate(360deg); }\n}\n\n.TaskRecordsPage-pagination {\n  display: flex;\n  min-height: 74px;\n  align-items: center;\n  justify-content: center;\n  color: var(--canvas-muted, #737b75);\n  font-size: 10px;\n}\n\n.TaskRecordsPage-pagination button:disabled {\n  cursor: wait;\n  opacity: 0.6;\n}\n\n@media (max-width: 900px) {\n  .TaskRecordsPage-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n}\n\n@media (max-width: 620px) {\n  .TaskRecordsPage-hero { padding: 28px 16px; }\n  .TaskRecordsPage-back { margin-bottom: 26px; }\n  .TaskRecordsPage-title-row { align-items: stretch; flex-direction: column; }\n  .TaskRecordsPage-total { min-width: 0; }\n  .TaskRecordsPage-content { padding: 20px 14px 60px; }\n  .TaskRecordsPage-toolbar { align-items: flex-start; flex-direction: column; gap: 12px; }\n  .TaskRecordsPage-sync { display: none; }\n  .TaskRecordsPage-grid { grid-template-columns: 1fr; }\n  .TaskRecordsPage-media { height: 210px; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .TaskRecordsPage-card { transition: none; }\n  .TaskRecordsPage-card:hover { transform: none; }\n  .TaskRecordsPage-spinner { animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
